webpackJsonp([205132826070588],{

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Management = function (_Component) {
	  _inherits(Management, _Component);
	
	  function Management() {
	    _classCallCheck(this, Management);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Management.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'insid-header activity-header', style: { marginTop: '100px' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-lg-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'insid-header-text activity-header-text' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'wow fadeIn', 'data-wow-duration': '.2s', 'data-wow-delay': '.1s' },
	                  'Strategic management e controllo di gestione'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'activity about2' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-lg-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'activity-text wow fadeIn animated', 'data-wow-duration': '.5s', 'data-wow-delay': '.2s' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'activity-h2' },
	                  'Dettagli'
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Supporto operativo nell\u2019',
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      'esecuzione'
	                    ),
	                    ' della ',
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      'strategia'
	                    ),
	                    ' aziendale attraverso:'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'list-none' },
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'list-square' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'valutazione della coerenza dei ',
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          'processi'
	                        ),
	                        ' interni e dei ',
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          'sistemi'
	                        ),
	                        ' (ERP ed applicativi specifici) in relazione alla strategia definita; consulenza, formazione e assistenza nelle attivit\xE0 di adeguamento eventualmente proposte.'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        'valutazione adeguatezza risorse umane in relazione alla strategia definita.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Consulenza e supporto operativo nello sviluppo di strumenti per la ',
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      'pianificazione'
	                    ),
	                    ' ed il controllo della gestione e del rischio d\u2019azienda, atti a guidare l\u2019Azienda nella corretta esecuzione dei ',
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      'programmi'
	                    ),
	                    ' e delle strategie:'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'list-none' },
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'list-square' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          'Business plan'
	                        ),
	                        ', ',
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          'Financial plan'
	                        ),
	                        ' e ',
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          'budget'
	                        ),
	                        '.'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          'Reporting'
	                        ),
	                        ' e ',
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          'Forecast'
	                        ),
	                        '.'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          'Balanced scorecard'
	                        ),
	                        '.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Supporto operativo nella velocizzazione del processo di reporting ',
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      'direzionale'
	                    ),
	                    ' periodico.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Assistenza nella scelta della configurazione del costo di prodotto in funzione delle necessit\xE0 e scopi aziendali (pricing, controllo industriale, valutazione scorte, etc.).'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Supporto operativo nel calcolo del ',
	                    _react2.default.createElement(
	                      'b',
	                      null,
	                      'costing'
	                    ),
	                    ' e delle marginalit\xE0 per prodotto e/o linea di prodotto.'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Supporto operativo per il calcolo del conto economico di commessa con evidenza dei costi diretti ed indiretti industriali e delle relative marginalit\xE0 e risultati operativi; consulenza nello sviluppo di strumenti per il controllo di commessa.'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Management;
	}(_react.Component);
	
	exports.default = Management;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-management-it-js-1d2ebb076e4c00c063dd.js